
import { loginState } from '@esg/framework';
import { useAtom } from 'jotai';

export function useResetLoginState() {
    const [, setModalState] = useAtom(loginState);
    return () => setModalState(loginState.init);
}